import React, { useState } from 'react';
import { submitEventWaitlist } from './eventRsvpApi';

const EventRsvpWaitlist = ({ event, memorial }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');

    const response = await submitEventWaitlist({
      event,
      memorial,
      guestName: name,
      guestEmail: email,
    });

    if (response?.status === 'success') {
      setSubmitted(true);
    } else {
      setError(response?.error || 'We could not save your request. Please try again.');
    }

    setSubmitting(false);
  };

  return (
    <div className="rounded-3xl border border-brand-dark bg-white p-6 shadow-sm">
      {submitted ? (
        <p className="text-center text-sm text-accent-navy" role="status">
          You’re on the update list for {event?.title || memorial?.name || 'this event'}.
        </p>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <h3 className="font-serif text-lg text-accent-navy">Get event updates</h3>
            <p className="mt-1 text-sm text-text-muted">Leave your email to receive updates about this event.</p>
          </div>
          <label className="sr-only" htmlFor="event-waitlist-name">Your name</label>
          <input
            id="event-waitlist-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Your name"
            autoComplete="name"
            required
            className="w-full rounded-xl border border-brand-dark px-4 py-3 text-sm"
          />
          <label className="sr-only" htmlFor="event-waitlist-email">Email address</label>
          <input
            id="event-waitlist-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email address"
            autoComplete="email"
            required
            className="w-full rounded-xl border border-brand-dark px-4 py-3 text-sm"
          />
          {error && <p className="text-sm text-red-700" role="alert">{error}</p>}
          <button
            type="submit"
            disabled={submitting}
            className="w-full rounded-xl bg-accent-navy px-4 py-3 text-sm font-bold text-white disabled:cursor-not-allowed disabled:opacity-60"
          >
            {submitting ? 'Saving…' : 'Get updates'}
          </button>
        </form>
      )}
    </div>
  );
};

export default EventRsvpWaitlist;